function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x36_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6AB5D3"
    },
    d: "M431.953,50.012V461.94c0,27.547-22.512,50.06-50.06,50.06H50.016 c-1.526,0-3.053-0.076-4.502-0.229c-1.526-0.076-2.976-0.305-4.426-0.61c-0.763-0.076-1.526-0.229-2.213-0.458 c-4.197-0.916-8.241-2.442-11.905-4.426c-0.076,0-0.076-0.076-0.076-0.076c-0.229-0.076-0.458-0.153-0.611-0.305 c-1.45-0.764-2.824-1.603-4.121-2.519c-1.602-0.992-3.129-2.137-4.502-3.434c-0.992-0.764-1.908-1.679-2.823-2.595 c-1.755-1.679-3.358-3.586-4.808-5.571c-0.458-0.61-0.916-1.297-1.374-1.908c-1.068-1.526-2.061-3.128-2.823-4.731 c-0.763-1.298-1.374-2.671-1.908-4.044c-0.611-1.374-1.145-2.824-1.603-4.35c-0.381-0.992-0.611-1.908-0.839-2.976 c-0.229-0.839-0.458-1.755-0.611-2.671c-0.153-0.764-0.229-1.602-0.381-2.366c0-0.153-0.076-0.306-0.076-0.457 c-0.229-2.061-0.381-4.198-0.381-6.333V179.36L179.363,0.028h202.53c5.876,0,11.523,0.991,16.712,2.975 c14.194,4.961,25.412,16.255,30.372,30.372c0.992,2.443,1.679,4.961,2.137,7.556c0.305,1.449,0.458,2.976,0.611,4.426 C431.877,46.882,431.953,48.486,431.953,50.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4884B9"
    },
    d: "M129.306,179.348c27.523,0,50.042-22.519,50.042-50.042V0L0,179.348H129.306z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.06,
      fill: "#040000"
    },
    d: "M431.953,50.012V461.94c0,27.547-22.512,50.06-50.06,50.06H50.016 c-1.526,0-3.053-0.076-4.502-0.229c-1.526-0.076-2.976-0.305-4.426-0.61c-0.763-0.076-1.526-0.229-2.213-0.458 c-4.197-0.916-8.241-2.442-11.905-4.426c-0.076,0-0.076-0.076-0.076-0.076c-0.229-0.076-0.458-0.153-0.611-0.305 c-1.45-0.764-2.824-1.603-4.121-2.519c-1.602-0.992-3.129-2.137-4.502-3.434c-0.992-0.764-1.908-1.679-2.823-2.595 c-1.755-1.679-3.358-3.586-4.808-5.571c-0.458-0.61-0.916-1.297-1.374-1.908c-1.068-1.526-2.061-3.128-2.823-4.731 c-0.763-1.298-1.374-2.671-1.908-4.044c-0.611-1.374-1.145-2.824-1.603-4.35c-0.381-0.992-0.611-1.908-0.839-2.976 c-0.229-0.839-0.458-1.755-0.611-2.671l204.362-204.362l11.752-11.676l9.92-9.996h0.076L431.114,40.931 c0.305,1.449,0.458,2.976,0.611,4.426C431.877,46.882,431.953,48.486,431.953,50.012z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#040000"
    },
    d: "M431.495,447.898v11.294c0,27.473-22.512,49.984-49.984,49.984H49.634 c-10.989,0-21.215-3.586-29.456-9.692c-4.273-3.053-7.937-6.792-11.065-11.065c-3.739-5.19-6.563-11.066-8.089-17.476 c-0.229-0.688-0.381-1.449-0.534-2.213c0-0.153-0.076-0.306-0.076-0.457l2.518-2.441c0.305,0.762,0.611,1.526,0.916,2.289 c7.86,17.475,25.488,29.838,45.787,29.838h331.878C408.984,497.959,431.495,475.447,431.495,447.898z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.71553dcf9613793ba426a35bf86524a0.svg";
export { ForwardRef as ReactComponent };